<a *ngIf="href"
   [href]="href"
   role="button"
   class="button {{ color ? 'button--' + color : '' }} {{ size ? 'button--' + size : '' }}"
   [class.button--square]="square"
   [class.disabled]="disabled ? true : null">
  {{ text }}
  <ng-content></ng-content>
</a>

<button *ngIf="!href"
        [type]="type"
        class="button {{ color ? 'button--' + color : '' }} {{ size ? 'button--' + size : '' }}"
        [class.button--square]="square"
        [attr.disabled]="disabled ? true : null">
  {{ text }}
  <ng-content></ng-content>
</button>
